import getApiClient from 'src/utils/getApiClient'
import getCSRFToken from 'src/utils/getCSRFToken'
import type {
  ApiDoctorAppointmentRestrictionsRequest,
  ApiDoctorAppointmentRestrictionsResponse,
} from 'src/components/common/DoctorAppointmentRestrictionsModal/types'

const apiClient = getApiClient()

export default {
  get(params: ApiDoctorAppointmentRestrictionsRequest) {
    return apiClient.get<ApiDoctorAppointmentRestrictionsResponse>(
      `/api/lpu/${params.lpu_id}/doctor/${params.doctor_id}/restriction-appointment/`,
      {
        headers: {
          'X-CSRFToken': getCSRFToken(),
        },
      },
    )
      .then(({ data }) => data)
  },
}
